"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataFallback = void 0;
const React = require("react");
const Button_1 = require("../../atoms/Button");
const defaultMessage_1 = require("./defaultMessage");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
/**
 * Used to display a missing info messsage when no children are passed through
 */
const NoDataFallback = props => {
    const { children, message = defaultMessage_1.defaultMessage, actions } = props;
    const hasContent = !!children;
    return (React.createElement("div", null,
        hasContent && React.createElement("div", { "data-test": "content" }, children),
        !hasContent && (React.createElement("div", { className: css("noDataCell"), "data-test": "fallback" },
            React.createElement("div", { "data-test": "message" }, message),
            actions && actions.length && (React.createElement("div", { className: css("noDataCell_actions"), "data-test": "actions" }, actions.map((action, i) => (React.createElement("div", { key: i, "data-test": `action-${i}` },
                React.createElement(Button_1.Button, { onClick: action.onClick }, action.label))))))))));
};
exports.NoDataFallback = NoDataFallback;
exports.default = exports.NoDataFallback;
//# sourceMappingURL=index.js.map